var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgModify = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.247 16.494A8.247 8.247 0 1 1 8.247 0a8.247 8.247 0 0 1 0 16.494zm4.114-10.83a.237.237 0 0 0 0-.335l-1.26-1.26a.237.237 0 0 0-.334 0l-6.294 6.294.008.008a.31.31 0 0 0-.142.196l-.332 1.487a.309.309 0 0 0 .37.37l1.486-.332a.309.309 0 0 0 .197-.142l.008.007.39-.39-1.595-1.594.605-.605 1.594 1.595 3.911-3.911L9.38 5.458l.605-.605 1.594 1.594.783-.783z",
  fill: "#FFF",
  fillRule: "evenodd"
})));
export default SvgModify;